import smuartwork from "../../Assets/Images/SMU-ARTWORK.jpg"
import smulogo from "../../Assets/Images/SMU.jpg"
import smimsLogo from "../../Assets/Images/SMIMS-logo-print.jpg"

export const banner1JPG = 'https://turbostart.blob.core.windows.net/turbostart/banner1.JPG';
export const banner2JPG = 'https://turbostart.blob.core.windows.net/turbostart/banner2.JPG';
export const banner1PNG = 'https://turbostart.blob.core.windows.net/turbostart/banner1.png';
export const banner2PNG = 'https://turbostart.blob.core.windows.net/turbostart/banner2.png';
export const smusmall = 'https://turbostart.blob.core.windows.net/turbostart/smusmall.png';

export const banner3JPG = smuartwork;
export const smulogoPNG = smulogo;
export const smimslogoPNG = smimsLogo;
